import React from 'react';
import {observer} from 'mobx-react';
import store from '../../../../s';
import {Portal} from '../../../../../util';

interface IEmptyCartProps {
    isMobile: boolean;
}

const EmptyCart = observer(({isMobile}: IEmptyCartProps) => {
    return (
        <>
            {isMobile && (!store.checkout.cart.items || store.checkout.cart.items.length < 1) && (
                <div
                    className="text-center"
                    style={{paddingTop: 24, paddingBottom: 24}}
                >
                    <div
                        className="form-inline-label"
                        style={{fontSize: 28}}
                    >
                        Your cart is empty.
                    </div>
                    {Portal?.PortalID === 3 && (
                        <div
                            className="link"
                            style={{marginTop: 36}}
                        >
                            <a
                                href="/"
                                title="Diploma Frames"
                            >
                                Visit our Framerly Shop
                            </a>
                        </div>
                    )}
                    {Portal?.PortalID === 0 && (
                        <div
                            className="link"
                            style={{marginTop: 36}}
                        >
                            <a
                                href="/shop-frames-gifts.aspx"
                                title="Diploma Frames"
                                aria-label="Visit our Shop Frames and Gifts page"
                            >
                                Visit our Shop Frames and Gifts page
                            </a>
                        </div>
                    )}
                    {Portal?.PortalID === 0 && (
                        <div
                            className="link"
                            style={{marginTop: 36}}
                        >
                            <a
                                href="/frame-designer"
                                title="Custom Frame"
                                aria-label="Custom Frame"
                            >
                                Create your own Custom Frame
                            </a>
                        </div>
                    )}
                    {Portal?.PortalID === 0 && (
                        <div
                            className="link"
                            style={{marginTop: 36}}
                        >
                            <a
                                href="/about-our-frames/frames-custom-made-for-you.aspx"
                                title="About Our Frames"
                                aria-label="About Our Frames"
                            >
                                Learn more about our frames
                            </a>
                        </div>
                    )}
                </div>
            )}

            {!isMobile && (!store.checkout.cart.items || store.checkout.cart.items.length < 1) && (
                <div
                    className="text-center"
                    style={{paddingTop: 24, paddingBottom: 24}}
                >
                    <div
                        className="form-inline-label"
                        style={{fontSize: 20}}
                    >
                        Empty cart
                    </div>
                </div>
            )}
        </>
    );
});

export default EmptyCart;
